import { render, staticRenderFns } from "./CotejoListo.vue?vue&type=template&id=c3ccd92e"
import script from "./CotejoListo.vue?vue&type=script&lang=js"
export * from "./CotejoListo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ccd92e')) {
      api.createRecord('c3ccd92e', component.options)
    } else {
      api.reload('c3ccd92e', component.options)
    }
    module.hot.accept("./CotejoListo.vue?vue&type=template&id=c3ccd92e", function () {
      api.rerender('c3ccd92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/staff/CotejoListo.vue"
export default component.exports